export default __webpack_public_path__ + "static/media/SkylineBanner.87c50b0c.jpg";